"use strict";
var appn;
(function (appn) {
    var intersectionObserver;
    (function (intersectionObserver) {
        function init() {
            setTimeout(function () {
                initImgLazyLoading();
            }, 250);
        }
        intersectionObserver.init = init;
        function initImgLazyLoading() {
            const lazyImages = [].slice.call(document.querySelectorAll('.lazy-loaded-image.lazy'));
            const lazyImageObserver = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        const lazyImage = entry.target;
                        lazyImage.addEventListener('load', function (e) {
                            afterImageLoaded(lazyImageObserver, lazyImage);
                        });
                        lazyImage.addEventListener('error', function () {
                            afterImageLoaded(lazyImageObserver, lazyImage);
                        });
                        lazyImage.src = lazyImage.dataset.imglazyurl;
                        lazyImage.closest('.appn-img-lazy-container').classList.remove('lazy');
                    }
                });
            });
            lazyImages.forEach(function (lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });
        }
        function afterImageLoaded(lazyImageObserver, lazyImage) {
            lazyImage.classList.remove('lazy');
            lazyImage.classList.add('img-load-complete');
            lazyImageObserver.unobserve(lazyImage);
        }
    })(intersectionObserver = appn.intersectionObserver || (appn.intersectionObserver = {}));
})(appn || (appn = {}));
